export default class FacetQueryBuilder {

  private params = new URLSearchParams(window.location.search);

  reset() {
    this.params = new URLSearchParams();
  }

  setValueAsQueryParameter = (input: JQuery) => {
    const name = input.attr('name') as string;
    const value = (input.val() as string).trim() || '';

    if (value.length) {
      this.params.set(name, value);
    } else {
      this.params.delete(name);
    }
  };

  setValueInFacetSearch = (input: JQuery, allowMultiple = false) => {
    const name = input.attr('name') as string;
    const value = (input.val() as string).trim() || '';
    const query = this.params.get('q') || ':productPopularitySort-desc';
    const queryHasValueForName = query.includes(name);

    if (!value.length) {
      if (queryHasValueForName) {
        this.params.set('q', this.removeValueFromFacetQuery(query, name));
      }
      return;
    }

    const nameValuePair = `${name}:${value}`;
    const isCurrentValueAlreadySet = query.includes(nameValuePair);
    if (isCurrentValueAlreadySet) {
      return;
    }

    if (queryHasValueForName && !allowMultiple) {
      this.params.set('q', this.replaceValueInFacetQuery(query, value, name));
    } else {
      this.params.set('q', `${query}:${nameValuePair}`);
    }
  };

  private replaceValueInFacetQuery(query: string, name: string, value: string): string {
    const facetParts: string[] = query.split(':');
    facetParts[facetParts.indexOf(name) + 1] = value;
    return facetParts.join(':');
  }

  private removeValueFromFacetQuery(query: string, name: string): string {
    const facetParts: string[] = query.split(':');
    facetParts.splice(facetParts.indexOf(name), 2);
    return facetParts.join(':');
  }

  removeValueAsQueryParameter(input: JQuery): void {
    const name = input.attr('name') as string;
    this.params.delete(name);
  }

  resetPaginationPageNumber(): void {
    this.params.delete('page');
  }

  resetFacetSearchQuery(): void {
    this.params.delete('q');
  }

  getQuery() {
    return this.params.toString();
  }

}
